import * as React from "react";

function SvgMinus(props) {
  return <svg width="1em" height="1em" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M15.122 1.667H.833A.833.833 0 11.833 0h14.29a.833.833 0 110 1.667z" fill="#000" /></svg>;
}

export default SvgMinus;